export default __webpack_public_path__ + "static/media/hex.084070cf.png";